.tableTextView {
  padding: 0.85rem 0.5rem;
  word-wrap: break-word;
  text-align: center;
}

th.tableTextView {
  letter-spacing: 0.045em;
}

td.tableTextView {
  font-variant-numeric: tabular-nums lining-nums;
  border-top: 1px solid var(--ib-line-2);
}

.nomineeTable {
  table-layout: fixed;
  width: 100%;
  border-spacing: 0;
  border: 1px solid var(--ib-line);
  border-radius: 10px;
  overflow: hidden;
}
